import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import tourInstallmentsApi from '@/features/dashboard/tourConfig/api/tourInstallmentsApi.ts';
import { tourPricingQueryKeys } from '@/features/dashboard/tourConfig/api/tourPricing.queryKeys.ts';
import { PriceRangeDto } from '@/features/shared/pricing/types/PriceRangeDto.ts';

export const getTourPriceRangeQueryOptions = (
  tourId: string,
): UseQueryOptions<PriceRangeDto[]> => ({
  queryKey: tourPricingQueryKeys.byTour(tourId),
  queryFn: () => tourInstallmentsApi.getPriceRanges(tourId),
  refetchOnMount: 'always',
});

const useGetTourPriceRange = (tourId: string | undefined) => {
  return useQuery({
    ...getTourPriceRangeQueryOptions(tourId!),
    enabled: !!tourId,
  });
};

export default useGetTourPriceRange;
